import { render, staticRenderFns } from "./PartnerPool.vue?vue&type=template&id=3dfc57cc&"
import script from "./PartnerPool.vue?vue&type=script&lang=ts&"
export * from "./PartnerPool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports